import React from 'react';

import { Avatar } from '../../Avatar/Avatar';
import { IPostCard } from '../Card';

import style from './PostAuthor.scss';

import Loadable from '@loadable/component';
import cn from 'classnames';
import { Link } from 'gatsby';

const PostStats = Loadable(() => import('../Stats'));

interface IProps {
  publishedAt: string;
  primary_author: {
    name: string;
    slug: string;
    profile_image: string;
  };
  post: IPostCard;
}

export const PostAuthor = ({ publishedAt, primary_author, post }: IProps) => {
  return (
    <div className={cn(style.author)}>
      <Avatar
        className={style.profileImage}
        profile_image={primary_author.profile_image}
        name={primary_author.name}
      />
      <div className={style.authorText}>
        <Link to={`/author/${primary_author.slug}/`}>
          {primary_author ? primary_author.name : ''}
        </Link>
        <PostStats
          publishedAt={publishedAt}
          isReadingTimeShown
          author={primary_author ? primary_author.name : ''}
          post={post}
        />
      </div>
    </div>
  );
};
